import makeApiRequest from './makeApiCall';

export const getPendingForReceive = async (
  params = {},
  otherOptions = {},
  isDdm = false,
) => {
  const requestParams = isDdm ? { ...params, is_ddm: true } : params;
  return await makeApiRequest(
    `/treasury/pending-receive`,
    'GET',
    null,
    requestParams,
    false,
    '',
    otherOptions,
  );
};

export const getReceived = async (params, otherOptions) => {
  return await makeApiRequest(
    `/treasury/received`,
    'GET',
    null,
    params,
    false,
    '',
    otherOptions,
  );
};

export const getPDC = async (params, otherOptions) => {
  return await makeApiRequest(
    `/treasury/pdc-on-hand`,
    'GET',
    null,
    params,
    false,
    '',
    otherOptions,
  );
};

export const getDeposited = async (params) => {
  return await makeApiRequest(`/treasury/deposited`, 'GET', null, params);
};

export const getClearedChecks = async (params, otherOptions) => {
  return await makeApiRequest(
    `/treasury/cleared-checks`,
    'GET',
    null,
    params,
    false,
    '',
    otherOptions,
  );
};

export const getReturned = async (params, otherOptions) => {
  return await makeApiRequest(
    `/treasury/returned`,
    'GET',
    null,
    params,
    false,
    '',
    otherOptions,
  );
};

export const getReDeposited = async (params, otherOptions) => {
  return await makeApiRequest(
    `/treasury/redeposited`,
    'GET',
    null,
    params,
    false,
    '',
    otherOptions,
  );
};

//Customer OA list
export const getCustomerAO = async (params) => {
  return await makeApiRequest(
    `/treasury/directdeposit/unidentified/customer_ao`,
    'GET',
    null,
    params,
  );
};

export const getIdentifiedDirectDeposit = async (params, otherOptions) => {
  return await makeApiRequest(
    `/treasury/identified-direct-deposit`,
    'GET',
    null,
    params,
    false,
    '',
    otherOptions,
  );
};

export const getCNCRemittance = async (params, otherOptions) => {
  return await makeApiRequest(
    `/treasury/cnc-remittance`,
    'GET',
    null,
    params,
    false,
    '',
    otherOptions,
  );
};

export const getDetail = async (collection_payment_details_id) => {
  return await makeApiRequest(
    `collection/treasury/view/details`,
    'GET',
    null,
    { collection_payment_details_id },
    false,
  );
};

// tag status
export const tagReceived = async (data) => {
  return await makeApiRequest(
    `/treasury/tag/receive`,
    'POST',
    null,
    data,
    false,
  );
};

export const tagDeposited = async (data) => {
  return await makeApiRequest(
    `/treasury/tag/deposited`,
    'POST',
    null,
    data,
    false,
  );
};

export const tagCleared = async (data) => {
  return await makeApiRequest(
    `/treasury/tag/cleared`,
    'POST',
    null,
    data,
    false,
  );
};

export const tagReturned = async (data) => {
  return await makeApiRequest(
    `/treasury/tag/returned`,
    'POST',
    null,
    data,
    false,
  );
};

export const tagRedeposit = async (data) => {
  return await makeApiRequest(
    `/treasury/tag/redeposit`,
    'POST',
    null,
    data,
    false,
  );
};

export const tagReturnToMaker = async (data) => {
  return await makeApiRequest(
    `/treasury/tag/return-to-maker`,
    'POST',
    null,
    data,
    false,
  );
};

export const tagRemitted = async (data) => {
  return await makeApiRequest(
    `/treasury/tag/remitted`,
    'POST',
    null,
    data,
    false,
  );
};

// dropdown
export const getReturnedReasons = async () => {
  return await makeApiRequest(
    `/treasury/return/reason`,
    'GET',
    null,
    null,
    false,
  );
};

// changes
export const changeDepositDate = async (data, withFile) => {
  return await makeApiRequest(
    `/treasury/changes/change_of_deposit_date`,
    'POST',
    null,
    data,
    withFile,
  );
};

export const changeBank = async (data, withFile) => {
  return await makeApiRequest(
    `/treasury/changes/change_of_bank`,
    'POST',
    null,
    data,
    withFile,
  );
};

export const getApprover = async () => {
  return await makeApiRequest(
    `treasury/changes/for_approvals`,
    'GET',
    null,
    null,
    false,
  );
};

export const setStatus = async (params) => {
  return await makeApiRequest(
    `/treasury/changes/approved_disapproved`,
    'POST',
    null,
    params,
    null,
    false,
  );
};

export const getListOfApprovals = async (id) => {
  return await makeApiRequest(
    `/treasury/changes/get_approval/` + id,
    'GET',
    null,
    id,
    null,
    false,
  );
};

// export const getStatusList = async (id) => {
//   return await makeApiRequest(
//     `/treasury/changes/approved_disapproved/list/` + id,
//     "GET",
//     null,
//     id,
//     null,
//     false
//   );
// };

//jhay
export const getApprovedData = async (params) => {
  return await makeApiRequest(
    `/treasury/changes/approved/lists`,
    'GET',
    null,
    params,
  );
};

export const getDeclinedData = async (params) => {
  return await makeApiRequest(
    `/treasury/changes/disapproved/lists`,
    'GET',
    null,
    params,
  );
};

export const getAllBanksAccounts = async (data) => {
  return await makeApiRequest(
    `/treasury/select/bank/account`,
    'GET',
    null,
    data,
  );
};

export const exportCollection = async (status, params = {}) => {
  return await makeApiRequest(
    `/treasury/export/${status}`,
    'GET',
    null,
    params,
  );
};

export const postCheckEditDetails = async (data) => {
  return await makeApiRequest(
    `/treasury/edit/check_bank_details`,
    'POST',
    null,
    data,
  );
};

export const postAwaitingConfirmation = async (params) => {
  return await makeApiRequest(
    `/treasury/awaiting_confirmation`,
    'POST',
    null,
    params,
    null,
    false,
  );
};

export const updatePulledOutStatus = async (data) => {
  return await makeApiRequest(`/treasury/returned/update`, 'PUT', null, data);
};

export const postCollectorName = async (data) => {
  return await makeApiRequest(
    `/treasury/directdeposit/unidentified/customer_ao/add`,
    'POST',
    null,
    data,
    null,
    false,
  );
};

export const postPrintCrNo = async (
  collection_payment_details_id,
  breakdown_ids = [],
  cr_print_no,
) => {
  return await makeApiRequest(
    `/collection/treasury/print-cr-no`,
    'POST',
    null,
    { collection_payment_details_id, breakdown_ids, cr_print_no },
    null,
    false,
  );
};

export const printCrNoPreview = async (collection_payment_details_id) => {
  return await makeApiRequest(
    `/collection/treasury/print-cr-no-preview`,
    'GET',
    null,
    {
      collection_payment_details_id,
    },
  );
};

export const approvedPayableVoucherOnlineCrediting = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/online_crediting/approved_pv`,
    'GET',
    null,
    data,
  );
};

export const approvedPayableVoucherCheckDeposit = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/check_deposit/approved_pv`,
    'GET',
    null,
    data,
  );
};

export const generatePayrollFile = async (data) => {
  return await makeApiRequest(
    `/generate/bank_template_bpi`,
    'POST',
    null,
    data,
  );
};

export const generatePayrollReport = async (data) => {
  return await makeApiRequest(
    `/generate/bank_payroll_report`,
    'POST',
    null,
    data,
  );
};

export const generateOlineCreditingExportReport = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/online_crediting/approved_pv/export`,
    'GET',
    null,
    data,
  );
};

export const generateCheckDepositExportReport = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/check_deposit/approved_pv/export`,
    'GET',
    null,
    data,
  );
};

export const checkVoucherTagging = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/check_voucher_tagging`,
    'POST',
    null,
    data,
  );
};

export const getPayableToEmployeesForOC = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/online_crediting/oc_preparation`,
    'GET',
    null,
    data,
  );
};

export const getPayableToEmployeesOCList = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/online_crediting/get_oc_listing`,
    'GET',
    null,
    data,
  );
};

export const postResendOnlineCreditingAdvice = async (notification_log_id) => {
  return await makeApiRequest(
    `/payable_to_employees/online_crediting/resend_notification`,
    'POST',
    null,
    { notification_log_id },
  );
};

export const postPayableToEmployeesOCF = async (data) => {
  return await makeApiRequest(`/generate/submit_ocf`, 'POST', null, data);
};

export const getPayableToEmployeesOCFDetails = async (payroll_file_id) => {
  return await makeApiRequest(`/ocf/detail`, 'GET', null, { payroll_file_id });
};

export const postPayableToEmployeesRTM = async (
  payroll_file_id,
  reason = null,
) => {
  return await makeApiRequest(`/ocf_tagging/rtm`, 'POST', null, {
    payroll_file_id,
    rtm_reason: reason,
  });
};

export const postPayableToEmployeesCancel = async (
  payroll_file_id,
  reason = null,
) => {
  return await makeApiRequest(`/ocf_tagging/cancel`, 'POST', null, {
    payroll_file_id,
    cancel_reason: reason,
  });
};

export const postPayableToEmployeesTreasury = async (payroll_file_id) => {
  return await makeApiRequest(`/ocf_tagging/approve_treasury`, 'POST', null, {
    payroll_file_id,
  });
};

export const postPayableToEmployeesAccounting = async (payroll_file_id) => {
  return await makeApiRequest(`/ocf_tagging/approve_accounting`, 'POST', null, {
    payroll_file_id,
  });
};

export const getPayableToEmployeesPrint = async (payroll_file_id) => {
  return await makeApiRequest(`/ocf/print`, 'GET', null, {
    payroll_file_id,
  });
};

export const postPayableToEmployeesUpdate = async (data) => {
  return await makeApiRequest(`generate/update_ocf`, 'POST', null, data);
};

export const exportOcPrepartionList = async (data) => {
  return await makeApiRequest(
    `/payable_to_employees/online_crediting/oc_preparation/export`,
    'GET',
    null,
    data,
  );
};

export const postLoadDCR = async (data) => {
  return await makeApiRequest(`/dcr/generate`, 'POST', null, data, true);
};

export const postSaveDCR = async (data) => {
  return await makeApiRequest(`/dcr/save`, 'POST', null, data, true);
};
export const postDCREmail = async (data) => {
  return await makeApiRequest(`/dcr/email`, 'POST', null, data, true);
};

export const getDCRArchiveListing = async () => {
  return await makeApiRequest(`dcr/archive`, 'GET', null, null, false);
};

export const getDcrViewSummary = async (id) => {
  return await makeApiRequest(
    `/dcr/view_summary/` + id,
    'GET',
    null,
    null,
    false,
  );
};
